import apiClient from './api.ts';
import { AcademicYearInputSchema, AcademicYearUpdateSchema } from '@/types/academic_year_schema.ts';

export default {
    async getAllAcademicYears(page: number = 1, limit: number = 20, sort: string = 'created_at', order: 'asc' | 'desc' = 'desc') {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
            sort,
            order
        });
        return await apiClient.get(`academic-years?${params}`);
    },
    async getAcademicYears(excludeStatus?: string[]) {
        const params = new URLSearchParams();
        if (excludeStatus && excludeStatus.length > 0) {
            params.append('exclude_status', excludeStatus.join(','));
        }
        return await apiClient.get(`academic-years?${params}`);
    },
    async createAcademicYear(academicYearInput: AcademicYearInputSchema) {
        return await apiClient.post(`academic-years`, academicYearInput);
    },
    async updateAcademicYear(academicYearId: number, update: AcademicYearUpdateSchema) {
        return await apiClient.put(`academic-years/${academicYearId}`, update);
    },
    async updateStatusAcademicYear(academicYearId: number, status: string) {
        return await apiClient.put(`academic-years/${academicYearId}/status/${status}`);
    },
    async deleteAcademicYear(academicYearId: number) {
        return await apiClient.delete(`academic-years/${academicYearId}`);
    },
    async getActiveAcademicYear() {
        return await apiClient.get(`academic-years/active`);
    },
    async updateAcademicYearToActive(academicYearId: number) {
        return await apiClient.put(`academic-years/${academicYearId}/active`)
    },

    // Wizard-specific methods
    async createClassesBatch(academicYearId: number, classes: Array<{grade_id: number, name: string, capacity: number}>) {
        return await apiClient.post(`academic-years/${academicYearId}/classes/batch`, { classes });
    },

    async generateReportingPeriods(academicYearId: number) {
        return await apiClient.post(`academic-years/${academicYearId}/reporting-periods/generate`);
    },

    async createReportingPeriods(academicYearId: number, periods: Array<{name: string, start_date: string, end_date: string, period_value: number, period_type: string}>) {
        return await apiClient.post(`academic-years/${academicYearId}/reporting-periods`, { reporting_periods: periods });
    },

    async validateSetup(academicYearId: number) {
        return await apiClient.get(`academic-years/${academicYearId}/setup-validation`);
    },

    // Get academic year structure (classes and reporting periods) for cloning
    async getAcademicYearStructure(academicYearId: number) {
        return await apiClient.get(`academic-years/${academicYearId}/structure`);
    }
};
